module.exports = __webpack_public_path__ + "img/testimonial-monique-g.04bf4401.png";